module.exports = __webpack_public_path__ + "static/img/home_zj.78dc9a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_zj.png
// module id = 7tXB
// module chunks = 0